import { LinkButton } from '@cian/ui-kit';
import { clickSellerGarantLink } from '../components/tracking';
import { IApplicationContext } from '../../common/types/applicationContext';

export const getHowItWork = (context: IApplicationContext['custom']) => [
  {
    id: 1,
    title: 'Подберём для вас лучшего агента',
    description:
      'Материнский капитал или незакрытая ипотека — найдём специалиста, у которого есть опыт работы с похожими объектами.',
    imageClass: 'step-1',
  },
  {
    id: 2,
    title: 'Подготовим объект к успешной продаже',
    description:
      'Агент оценит недвижимость, чтобы не продешевить, напишет текст объявления и сфотографирует так, что её захочется купить',
    imageClass: 'step-2',
  },
  {
    id: 3,
    title: 'Ваше объявление увидят все',
    description:
      'Бесплатно подключим продвижение и отправим рекомендации потенциальным покупателям, чтобы объект продался быстрее',
    imageClass: 'step-3',
  },
  {
    id: 4,
    title: 'Звонки и просмотры — тоже на нас',
    description:
      'Агент возьмёт на себя общение с покупателями, презентацию объекта и добьётся лучшей цены — чтобы вы приложили минимум усилий и получили максимум прибыли',
    imageClass: 'step-4',
  },
  {
    id: 5,
    title: 'Вы в надёжных руках',
    description:
      'Мошенники не пройдут: агент поможет оформить документы без ошибок и убедится в безопасности расчётов, а Циан будет за всем присматривать',
    imageClass: 'step-5',
  },
  {
    id: 6,
    title: 'Поможем купить жильё взамен',
    description: 'Подарим сертификат защиты права собственности, если продаёте и покупаете с нами',
    imageClass: 'step-6',
    button: (
      <LinkButton
        size="M"
        theme="fill_secondary"
        href="https://static.cdn-cian.ru/frontend/collections-assets/cpd/landing/sert.pdf"
        target="_blank"
        onClick={() => clickSellerGarantLink(context, 'SafeDealCertificateExample')}
      >
        Посмотреть пример сертификата
      </LinkButton>
    ),
  },
];
